// @flow

import React from 'react';

// -- views
import AbstractFormComponent from 'components/form/AbstractFormComponent';

/**
 * You have to implements the following methods:
 * - shouldUpdateState(): boolean returns true if the object on props have changed.
 */
export default class AbstractRestaurantMenuForm extends AbstractFormComponent {

  state = this.getDefaultState(this.props);

  componentWillReceiveProps(nextProps: Object) {
    // We don't use restaurautMenu because we don't copy it, so the both restaurantMenu on
    // nextProps and props aren't equals.
    if (this.shouldUpdateState(nextProps)) {
      // restaurant menu have changed, we reset the form.
      this.setState(this.getDefaultState(nextProps));
    }
  }

  shouldUpdateState(): boolean {
    return false;
  }

  /**
   * Should be override.
   * See componentWillReceiveProps
   */
  shouldDisableSubmit(): boolean {
    return false;
  }

}
